import React from "react";
import IconWrapper from "./IconWrapper";
import { MdSportsHandball } from "react-icons/md";

const IconHandball = () => {

    return (
        <IconWrapper>
            <MdSportsHandball size="40px" />            
        </IconWrapper>
    );
}

export default IconHandball;
